import ActionTypes from '../actions/types'
import { createReducer } from 'reduxsauce'
import Utils from '../utils/Utils'

const INITIAL_STATE = {
  contacts: [],
  invitedContacts: [],
  phoneContacts: [],
  totalNumberOfContacts: 0,
  contactsLastUpdatedAt: 0
}

const addContact = (state, action) => {
  const contact = action.payload.contact
  let contactIndex = Utils.getIndexOfObjectWithId(state.contacts, contact.id)

  let newContacts

  if (contactIndex === -1) {
    newContacts = [...state.contacts, contact]
  } else {
    const existingContact = state.contacts[contactIndex]
    newContacts = state.contacts.map((c, index) =>
      index === contactIndex ? { ...existingContact, ...contact } : c
    )
  }

  return {
    ...state,
    contacts: newContacts
  }
}

const addInvitedContact = (state, action) => {
  const contact = action.payload.contact
  let contactIndex = Utils.getIndexOfObjectWithId(
    state.invitedContacts,
    contact.id
  )

  let newInvitedContacts

  if (contactIndex === -1) {
    newInvitedContacts = [...state.invitedContacts, contact]
  } else {
    const existingContact = state.invitedContacts[contactIndex]
    newInvitedContacts = state.invitedContacts.map((c, index) =>
      index === contactIndex ? { ...existingContact, ...contact } : c
    )
  }

  return {
    ...state,
    invitedContacts: newInvitedContacts
  }
}

const addPhoneContacts = (state, action) => {
  const phoneContacts = action.payload.phoneContacts
  return {
    ...state,
    phoneContacts: phoneContacts
  }
}

const addContacts = (state, action) => {
  const contacts = action.payload.contacts

  // Build index map for O(1) lookups
  const existingContactsMap = new Map(
    state.contacts.map((contact, index) => [contact.id, index])
  )

  // Merge contacts
  const updatedContacts = [...state.contacts]
  const newContactsToAdd = []

  contacts.forEach(contact => {
    const existingIndex = existingContactsMap.get(contact.id)
    if (existingIndex !== undefined) {
      // Update existing contact
      updatedContacts[existingIndex] = {
        ...updatedContacts[existingIndex],
        ...contact
      }
    } else {
      // Queue new contact for addition
      newContactsToAdd.push(contact)
    }
  })

  return {
    ...state,
    contacts: [...updatedContacts, ...newContactsToAdd]
  }
}

const deleteContact = (state, action) => {
  const { contactId } = action.payload
  let contactIndex = Utils.getIndexOfObjectWithId(state.contacts, contactId)

  if (contactIndex !== -1) {
    const newContacts = state.contacts.filter(
      (_, index) => index !== contactIndex
    )
    return {
      ...state,
      contacts: newContacts
    }
  }

  return state
}

const deleteInvitedContact = (state, action) => {
  const { contactId } = action.payload
  let contactIndex = Utils.getIndexOfObjectWithId(
    state.invitedContacts,
    contactId
  )

  if (contactIndex !== -1) {
    const newInvitedContacts = state.invitedContacts.filter(
      (_, index) => index !== contactIndex
    )
    return {
      ...state,
      invitedContacts: newInvitedContacts
    }
  }

  return state
}

const setContactAvatarImages = (state, action) => {
  let { contactId, images } = action.payload
  let contactIndex = Utils.getIndexOfObjectWithId(state.contacts, contactId)

  if (contactIndex !== -1) {
    const contact = state.contacts[contactIndex]
    const newContacts = state.contacts.map((c, index) =>
      index === contactIndex ? { ...contact, images: images } : c
    )
    return {
      ...state,
      contacts: newContacts
    }
  }

  return state
}

const deleteContactAvatarImages = (state, action) => {
  let { contactId } = action.payload
  let images = {}

  let contactIndex = Utils.getIndexOfObjectWithId(state.contacts, contactId)

  if (contactIndex !== -1) {
    const contact = state.contacts[contactIndex]
    const newContacts = state.contacts.map((c, index) =>
      index === contactIndex ? { ...contact, images: images } : c
    )
    return {
      ...state,
      contacts: newContacts
    }
  }

  return state
}

const setTotalNumberOfContacts = (state, action) => {
  const { totalNumberOfContacts } = action.payload

  return {
    ...state,
    totalNumberOfContacts
  }
}

const setContactsLastUpdatedAt = (state, action) => {
  const { contactsLastUpdatedAt } = action.payload

  return {
    ...state,
    contactsLastUpdatedAt
  }
}

const ACTION_HANDLERS = {
  [ActionTypes.ADD_CONTACT]: addContact,
  [ActionTypes.ADD_CONTACTS]: addContacts,
  [ActionTypes.ADD_PHONE_CONTACTS]: addPhoneContacts,
  [ActionTypes.ADD_INVITED_CONTACT]: addInvitedContact,
  [ActionTypes.DELETE_CONTACT]: deleteContact,
  [ActionTypes.DELETE_INVITED_CONTACT]: deleteInvitedContact,
  [ActionTypes.SET_CONTACT_AVATAR_IMAGES]: setContactAvatarImages,
  [ActionTypes.DELETE_CONTACT_AVATAR_IMAGES]: deleteContactAvatarImages,
  [ActionTypes.SET_TOTAL_NUMBER_OF_CONTACTS]: setTotalNumberOfContacts,
  [ActionTypes.SET_CONTACTS_LAST_UPDATED_AT]: setContactsLastUpdatedAt
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
